<div class="">
  <div class="section-authentication-cover">
    <div class="">
      <div class="row g-0">
        <div
          class="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex"
        >
          <div
            class="card shadow-none bg-transparent shadow-none rounded-0 mb-0"
          >
            <div class="card-body">
              <img
                src="assets/images/CDBlack.png"
                class="img-fluid auth-img-cover-login"
                width="490"
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          class="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center"
        >
          <div class="card rounded-0 m-3 shadow-none bg-transparent mb-0">
            <div class="card-body">
              <div class="text-center mb-3">
                <h3 class="mb-lg-3 mb-2">Sign Up</h3>
                <h5>Please create your account ✅</h5>
                <form-error [form]="form"></form-error>
              </div>
              <!-- <div class="form-body">
                  <form class="row g-3" *ngIf="!isLogin" #signupform="ngForm">
                    <div class="col-12">
                      <label for="firstName" class="form-label"
                        >FirstName</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="firstName"
                        name="firstName"
                        placeholder="Enter FirstName"
                        [(ngModel)]="form.data['firstName']"
                        required
                      />
                    </div>

                    <div class="col-12">
                      <label for="lastName" class="form-label">LastName</label>
                      <input
                        type="text"
                        class="form-control"
                        id="lastName"
                        name="lastName"
                        placeholder="Enter LastName"
                        [(ngModel)]="form.data['lastName']"
                        required
                      />
                    </div>

                    <div class="col-12">
                      <label for="login" class="form-label"
                        >Email Address</label
                      >
                      <input
                        type="email"
                        class="form-control"
                        id="loginId"
                        name="loginId"
                        placeholder="Enter Email"
                        [(ngModel)]="form.data['loginId']"
                        required
                        [readOnly]="isreadonly"
                      />
                    </div>
                    <div class="col-12">
                      <label for="inputChoosePassword" class="form-label"
                        >Password</label
                      >
                      <div class="input-group" id="show_hide_password">
                        <input
                          [type]="showPassword ? 'text' : 'password'"
                          class="form-control border-end-0"
                          id="password"
                          name="password"
                          [(ngModel)]="form.data['password']"
                          placeholder="Enter Password"
                          required
                        />
                        <a
                          href="javascript:;"
                          class="input-group-text bg-transparent"
                          (click)="togglePasswordVisibility()"
                          ><i class="bx bx-hide"></i
                        ></a>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="d-grid">
                        <button
                          type="submit"
                          (click)="signup()"
                          class="btn btn-primary"
                          [disabled]="!signupform.valid"
                        >
                          Sign up
                        </button>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="text-center">
                        <p class="mb-0">
                          Already have an account?
                          <a routerLink="/login">Sign in here</a>
                        </p>
                      </div>
                    </div>
                  </form>

                  <div *ngIf="isLogin" class="form-group form-row ml-5">
                    <label
                      for="email"
                      class="col-sm-12 col-form-label col-form-label-sm"
                    >
                      <h4>Hi, {{ form.data["firstName"] }}</h4>
                      <p>
                        You have been registered, your login id is
                        {{ form.data["loginId"] }}
                      </p>
                      <p>Please click button to login</p>
                    </label>
                    <a
                      class="btn btn-outline-primary btn-sm"
                      (click)="gotoLogin()"
                      ><i class="fas fa-sign-out-alt"></i>Login</a
                    >
                  </div>
                </div> -->

              <div class="form-body">
                <form
                  class="auth-form row g-2"
                  *ngIf="!isLogin"
                  #signupform="ngForm"
                >
                  <!-- First Name -->
                  <div class="col-12">
                    <mat-label>First Name</mat-label>
                    <mat-form-field
                      appearance="outline"
                      class="auth-field w-100"
                    >
                      <mat-icon matPrefix class="text-secondary opacity-50">
                        person_outline
                      </mat-icon>
                      <input
                        matInput
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder="Enter First Name"
                        [(ngModel)]="form.data['firstName']"
                        required
                      />
                    </mat-form-field>
                  </div>

                  <!-- Last Name -->
                  <div class="col-12">
                    <mat-label>Last Name</mat-label>

                    <mat-form-field
                      appearance="outline"
                      class="auth-field w-100"
                    >
                      <mat-icon matPrefix class="text-secondary opacity-50">
                        person_outline
                      </mat-icon>
                      <input
                        matInput
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder="Enter Last Name"
                        [(ngModel)]="form.data['lastName']"
                        required
                      />
                    </mat-form-field>
                  </div>

                  <!-- Email -->
                  <div class="col-12">
                    <mat-label>Email Address</mat-label>

                    <mat-form-field
                      appearance="outline"
                      class="auth-field w-100"
                    >
                      <mat-icon matPrefix class="text-secondary opacity-50">
                        mail_outline
                      </mat-icon>

                      <input
                        matInput
                        type="email"
                        id="loginId"
                        name="loginId"
                        placeholder="Enter Email"
                        [(ngModel)]="form.data['loginId']"
                        required
                        [readOnly]="isreadonly"
                      />
                    </mat-form-field>
                  </div>

                  <!-- Password -->
                  <div class="col-12">
                    <mat-label>Password</mat-label>

                    <mat-form-field
                      appearance="outline"
                      class="auth-field w-100"
                    >
                      <mat-icon matPrefix class="text-secondary opacity-50">
                        lock_outline
                      </mat-icon>

                      <input
                        matInput
                        [type]="showPassword ? 'text' : 'password'"
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        [(ngModel)]="form.data['password']"
                        required
                      />

                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="visibility-btn"
                        (click)="togglePasswordVisibility()"
                      >
                        <mat-icon class="text-secondary">
                          {{ showPassword ? "visibility" : "visibility_off" }}
                        </mat-icon>
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- Submit -->
                  <div class="col-12">
                    <div class="w-100 my-3">
                      <button
                        mat-raised-button
                        color="primary"
                        type="submit"
                        class="w-100 fat-button shadow-sm"
                        (click)="signup()"
                        [disabled]="!signupform.valid"
                      >
                        <span class="fs-6 tracking-wider">Sign Up</span>
                      </button>
                    </div>
                  </div>

                  <!-- Login Redirect -->
                  <div class="col-12 text-center mt-2">
                    <p class="mb-0 text-muted">
                      Already have an account?

                      <a
                        routerLink="/login"
                        class="text-decoration-none fw-bold ms-1"
                        style="color: #3f51b5"
                      >
                        Sign in here
                      </a>
                    </p>
                  </div>
                </form>

                <!-- Success Section -->
                <div *ngIf="isLogin" class="form-group form-row ml-5">
                  <label
                    for="email"
                    class="col-sm-12 col-form-label col-form-label-sm"
                  >
                    <h4>Hi, {{ form.data["firstName"] }}</h4>

                    <p>
                      You have been registered, your login id is
                      {{ form.data["loginId"] }}
                    </p>

                    <p>Please click button to login</p>
                  </label>

                  <button
                    mat-raised-button
                    color="primary"
                    type="button"
                    class="mt-2"
                    (click)="gotoLogin()"
                  >
                    <mat-icon>login</mat-icon>
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
